// extracted by mini-css-extract-plugin
export default {"wrapper":"vendors_wrapper__IP1MP","header":"vendors_header__Os6-s"};